import { createContext, useContext } from "react";

const ChatControlContext = createContext({});

export const ChatControlContextProvider = ChatControlContext.Provider;
export const ChatControlContextConsumer = ChatControlContext.Consumer;

export const useChatControlContext = () => useContext(ChatControlContext);

export default ChatControlContext;
